import { render, staticRenderFns } from "./editqz.vue?vue&type=template&id=c3fec724&scoped=true"
import script from "./editqz.vue?vue&type=script&lang=js"
export * from "./editqz.vue?vue&type=script&lang=js"
import style0 from "./editqz.vue?vue&type=style&index=0&id=c3fec724&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fec724",
  null
  
)

export default component.exports